var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36C11.16 36 4 28.84 4 20C4 11.16 11.16 4 20 4C28.84 4 36 11.16 36 20C36 28.83 28.83 36 20 36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3397 25.6598L18.2997 25.7898C19.4297 25.8298 20.5597 25.8298 21.6897 25.7898L25.6497 25.6598C27.0097 25.6198 28.1197 24.5298 28.1797 23.1698L28.2097 22.4698C28.2897 20.8298 28.2897 19.1798 28.2097 17.5398L28.1797 16.8698C28.1197 15.5098 27.0197 14.4298 25.6697 14.3798L21.8597 14.2298C20.6197 14.1798 19.3697 14.1798 18.1297 14.2198L14.3397 14.3398C12.9797 14.3798 11.8697 15.4698 11.8097 16.8298L11.7797 17.5498C11.6997 19.1798 11.6997 20.8198 11.7797 22.4498L11.8097 23.1698C11.8697 24.5298 12.9697 25.6098 14.3397 25.6598Z",
    fill: "#72BF44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5501 19.9997L18.3301 17.4897V22.3997L22.5501 19.9997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.08578f3d66ccfe875af6e4bbc2cc50d9.svg";
export { ForwardRef as ReactComponent };